


















import { faInfoCircle, faTimes } from '@fortawesome/free-solid-svg-icons'
import { mapGetters } from 'vuex'
import { APP_NS } from '~/store/modules/shared/app/state'
import { ciList } from '~/icons/source/solid/list'
import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  components: {
    CClassifiedListPopover: () =>
      import(
        '~/components/shared/configurable/classified/list/CClassifiedListPopover.vue'
      )
  },
  props: {
    classified: { type: Object, required: true },
    round: { type: Boolean, required: false },
    isModal: { type: Boolean, default: false }
  },
  data() {
    return {
      popoverVisible: false
    }
  },
  computed: {
    icons() {
      return {
        info: faInfoCircle,
        close: faTimes,
        list: ciList
      }
    },
    ...mapGetters(APP_NS, {
      isPlot: 'isPlot'
    })
  },
  methods: {
    togglePopover() {
      if (!this.popoverVisible) {
        this.$analytics.recordEvent({
          namespace: 'n_lists_button_clicked_in_classified',
          action: 'click',
          label: this.classified.title + ' (' + this.classified.id + ')'
        })
      }

      this.popoverVisible = !this.popoverVisible
    },
    hidePopover() {
      this.popoverVisible = false
    }
  }
})
